import { AxiosPromise } from 'axios-cad-nx';
import { ApiResultListCompleteClientUnitView, UnitResource } from '@mark43/cad-api';
import { useCallback } from 'react';
import { useApiClient } from '@m43/core';
import { useApplicationType } from '../common/hooks/use-application-type';

export function useSetUnitsOffDutyApi(): (
    unitIds: number[]
) => AxiosPromise<ApiResultListCompleteClientUnitView> {
    const { isFirstResponder } = useApplicationType();
    const apiClient = useApiClient();
    return useCallback(
        (unitIds: number[]) => {
            if (isFirstResponder) {
                return apiClient.request<UnitResource.TakeUnitsFirstResponderOffDuty>({
                    method: 'POST',
                    url: 'unit/first_responder/off_duty/',
                    data: unitIds,
                });
            }

            return apiClient.request<UnitResource.TakeUnitsOffDuty>({
                method: 'POST',
                url: 'unit/off_duty/',
                data: unitIds,
            });
        },
        [apiClient, isFirstResponder]
    );
}
